import { VcenterBaseDataProvider } from './VcenterBaseDataProvider';
import { VcenterWebComponentSchema } from '../types';

export class VcenterNirvanaDataProvider extends VcenterBaseDataProvider {
  async getDataForView(): Promise<VcenterWebComponentSchema> {
    return {} as unknown as VcenterWebComponentSchema;
  }
}
